import $ from 'jquery';

const OFFSET = 16;
const loadMore = () => {
  const loadMoreArticles = $('#load-more-articles');
  const searchItems = $('#search-items');

  if (loadMoreArticles.length) {
    loadMoreArticles.click(ev => {
      ev.preventDefault();
      const $self = $(ev.target);
      const $offset = $self.data('offset');
      const $tag = $self.data('tag');
      const $author = $self.data('author');
      const $cat = $self.data('cat');
      const $exclude = $self.data('exclude');
      $.ajax({
        type: 'GET',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'ajax_get_more_posts',
          s: window.location.search,
          offset: $offset,
          tag: $tag,
          a: $author,
          cat: $cat,
          exclude: $exclude,
        },
        success: res => {
          const $res = JSON.parse(res);
          const newOffset = $offset + OFFSET;
          loadMoreArticles.data('offset', newOffset);
          loadMoreArticles.attr('data-offset', newOffset);
          searchItems.append($res.html);
          if ($res.end) {
            loadMoreArticles.remove();
          }
        },
      });
    });
  }
};
export default loadMore;



// WEBPACK FOOTER //
// ./src/scripts/modules/load-more-articles.js